import api from '../lib/api';
import { buildListQuery, type ListQueryInput } from '../lib/buildListQuery';
import type { Manufacturer, ManufacturerInput, Paginated } from '../types';

export type ListManufacturersParams = ListQueryInput;

export const manufacturerService = {
  list: async (params?: ListManufacturersParams): Promise<Paginated<Manufacturer>> => {
    const response = await api.get<Paginated<Manufacturer>>('/manufacturers', { params: buildListQuery(params) });
    return response.data;
  },

  get: async (id: number): Promise<Manufacturer> => {
    const response = await api.get<{ data: { attributes: Manufacturer } }>(`/manufacturers/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: ManufacturerInput): Promise<Manufacturer> => {
    const response = await api.post<{ data: { attributes: Manufacturer } }>('/manufacturers', { manufacturer: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: ManufacturerInput): Promise<Manufacturer> => {
    const response = await api.patch<{ data: { attributes: Manufacturer } }>(`/manufacturers/${id}`, { manufacturer: data });
    return response.data.data.attributes;
  },

  destroy: async (id: number): Promise<void> => {
    await api.delete(`/manufacturers/${id}`);
  },

  toggleActive: async (id: number): Promise<Manufacturer> => {
    const response = await api.patch<{ data: { attributes: Manufacturer } }>(`/manufacturers/${id}/toggle_active`);
    return response.data.data.attributes;
  },
};

export default manufacturerService;
